var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.949l6.902 11.926H4.097L11 3.949zm0-3.657L.917 17.708h20.166L11 .292z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.916 13.125h-1.833v1.833h1.833v-1.833zM11.916 7.625h-1.833v4.583h1.833V7.625z"
  })));
}
export default SvgWarning;